import { useEffect } from 'react';
import { useAuthReady } from './useAuthReady';
import { useEstadosStore } from '../store/estadosStore';

export const useEstados = () => {
  const isAuthReady = useAuthReady();
  const { 
    estadosInternos, 
    estadosInternosInverso, 
    estadosMP,
    estadosMPInverso,
    isLoadedInternos,
    isLoadedMP,
    fetchAllEstados
  } = useEstadosStore();

  useEffect(() => {
    if (isAuthReady && (!isLoadedInternos || !isLoadedMP)) {
      fetchAllEstados();
    }
  }, [isAuthReady, isLoadedInternos, isLoadedMP, fetchAllEstados]);

  return {
    estados: estadosInternos,
    estadosInverso: estadosInternosInverso,
    estadosMP,
    estadosMPInverso,
    isLoaded: isLoadedInternos && isLoadedMP,
    isLoadedInternos,
    isLoadedMP,
    fetchEstados: fetchAllEstados
  };
}; 